export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13120.559221df.jpg";